import styled from "@emotion/styled";
import { useEffect, useRef } from "react";
import { Trans } from "react-i18next";
import {
  SectionContent,
  SectionHeading,
  SectionLargeText,
} from "../shared/Section";
import splitText from "../shared/splitText";
import useStore from "../shared/useStore";

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  text-align: right;
`;

const Keywords = styled.ul`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 1rem;
  max-width: 440px;
  width: 100%;
  list-style: none;
  margin-bottom: 0.5rem;
  @media (${(props) => props.theme.breakpoint}) {
    justify-content: flex-start;
  }
`;

const Skills = ({ visible }) => {
  const heading = useRef();

  useEffect(() => {
    if (heading) {
      splitText(heading.current);
    }
  }, [heading]);

  const updateActiveSkill = useStore((state) => state.updateActiveSkill);

  const mouseLeave = () => {
    updateActiveSkill(null);
  };

  const keywords = [
    {
      label: "Javascript",
      onmouseover: () => updateActiveSkill(0),
    },
    {
      label: "React.js",
      onmouseover: () => updateActiveSkill(0),
    },
    {
      label: "GSAP",
      onmouseover: () => updateActiveSkill(1),
    },
    {
      label: "CSS",
      onmouseover: () => updateActiveSkill(0),
    },
    {
      label: "React Three Fiber",
      onmouseover: () => updateActiveSkill(0),
    },
    {
      label: "Node.js",
      onmouseover: () => updateActiveSkill(0),
    },
    {
      label: "Figma",
      onmouseover: () => updateActiveSkill(1),
    },
    {
      label: "BtB UX",
      onmouseover: () => updateActiveSkill(1),
    },
  ];

  return (
    <SectionContent
      align="right"
      className={visible ? "section-content active" : "section-content"}
    >
      <SectionHeading textAlign="right" ref={heading}>
        <Trans i18nKey={"SkillsSection.title"}>
          <strong>Code</strong>, <strong>design</strong> and{" "}
          <strong>teaching</strong>
          <br />
          that’s all about me
        </Trans>
      </SectionHeading>
      <Content>
        <SectionLargeText textAlign="right" maxWidth="500px">
          <Trans i18nKey={"SkillsSection.description"} />
        </SectionLargeText>
        <Keywords>
          {keywords.map((keyword, index) => (
            <li
              key={index}
              onMouseOver={keyword.onmouseover}
              onMouseLeave={mouseLeave}
            >
              {keyword.label}
            </li>
          ))}
        </Keywords>
      </Content>
    </SectionContent>
  );
};

export default Skills;
